import _axios from './axios'
import {request as orequest, psCoreRequest} from '../../../../api'
import {psCore} from '../../../../api/axios'

async function request(url, params) {
  return await orequest(url, params, _axios)
}

// start olang





export async function _fetchTagList(page = 1, pageSize = 50, srcIds = null, srcObject = 'engin') {
  const requestData = {
    All: 0, // Use pagination instead of All
    page: page,
    PageSize: pageSize,
    srcObject: 'sensor'
  }
  
  // Add srcIds if provided
  if (srcIds && Array.isArray(srcIds) && srcIds.length > 0) {
    requestData.srcIds = srcIds
  }
  
  console.log('📡 _fetchTagList request data:', requestData)
  
  return await _axios.post('tag/list', requestData)
}

// New function for engin/list endpoint
export async function _fetchEnginList(data) {
  return await _axios.post('engin/list',data)
}

export async function _getTagHistories(data) {
  console.log('_getTagHistories called with:', data)
  console.log('_getTagHistories data structure:', typeof data)
  
  // Support both old format (array of macAddresses) and new format (object with tags, from, to, mode, group)
  let requestData
  if (Array.isArray(data)) {
    // Old format: convert array to new format
    console.log(' Converting old format (array) to new format')
    requestData = {
      tags: data,
      from: null,
      to: null,
      srcObject: 'engin' // Default srcObject for backward compatibility
    }
  } else if (data && typeof data === 'object') {
    // New format: use as is
    console.log('Using new format (object)')
    requestData = {
      tags: [],
      from: data.from || null,
      to: data.to || null,
      srcObject: 'engin' // Default srcObject
    }
    
    // Add srcIds if provided
    if (data.srcIds && Array.isArray(data.srcIds) && data.srcIds.length > 0) {
      requestData.srcIds = data.srcIds
    }
    
    // Add group parameter if specified
    if (data.group !== undefined) {
      requestData.group = data.group
    }
    
    // Add mode parameter if specified (for backward compatibility)
  } else {
    throw new Error('Invalid data format for _getTagHistories')
  }
  
  console.log('Final request data:', requestData)
  
  try {
    // Use direct axios call to have full control over data format
    const response = await _axios.post('tag/getTagHistories', requestData, {
      headers: {
        'Content-Type': 'application/json'
      },
    })
    
    console.log('Direct axios response:', response.data)
    console.log('Response data type:', typeof response.data)
    console.log('Response data keys:', response.data ? Object.keys(response.data) : 'no data')
    console.log('Response.data.response:', response.data?.response)
    console.log('Response.data.response type:', typeof response.data?.response)
    
    if (response.data?.response && Array.isArray(response.data.response)) {
      console.log('✅ Found history array in response.data.response:', response.data.response.length, 'records')
    } else {
      console.log('❌ No history array found in response.data.response')
    }
    
    return response.data
  } catch (error) {
    console.error('🚨 Direct axios error:', error)
    throw error
  }
}

// Alert API endpoints
export async function _getAlertList(data) {
  console.log('🚨 _getAlertList called - fetching all alerts')
  
  try {
    const response = await _axios.post('alert/list',data)
    console.log('🚨 Alert list response:', response.data)
    return response.data
  } catch (error) {
    console.error('🚨 Alert list error:', error)
    throw error
  }
}

export async function _getAllAlertHistories(data = {}) {
  console.log('📅 _getAllAlertHistories called - fetching all alert histories')
  
  try {
    const response = await _axios.post('alert/histories', {
      ...data,
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    console.log('📅 All alert histories response:', response.data)
    return response.data
  } catch (error) {
    console.error('📅 All alert histories error:', error)
    throw error
  }
}

export async function _saveAlert(data) {
  console.log('🚨 _saveAlert called with:', data)
  
  try {
    const response = await _axios.post('alert/save', data, {
      headers: {
        'Content-Type': 'application/json'
      },
    })
    
    console.log('🚨 Save alert response:', response.data)
    return response.data
  } catch (error) {
    console.error('🚨 Save alert error:', error)
    throw error
  }
}

export async function _deleteAlert(alertId) {
  console.log('🗑️ _deleteAlert called with ID:', alertId)
  
  try {
    const response = await _axios.post('alert/remove', { id: alertId }, {
      headers: {
        'Content-Type': 'application/json'
      },
    })
    
    console.log('🗑️ Delete alert response:', response.data)
    return response.data
  } catch (error) {
    console.error('🗑️ Delete alert error:', error)
    throw error
  }
}

export async function _getAlertHistories(data) {
  console.log('🚨 _getAlertHistories called with:', data)
  
  // Validate required parameters
  if (!data || !data.tagID) {
    throw new Error('tagID is required for _getAlertHistories')
  }
  
  const requestData = {
    tagID: data.tagID,
    from: data.from || null,
    to: data.to || null
  }
  
  console.log('🚨 Alert histories request data:', requestData)
  
  try {
    const response = await _axios.post('alert/getHistories', requestData, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    console.log('🚨 Alert histories response:', response.data)
    return response.data
  } catch (error) {
    console.error('🚨 Alert histories error:', error)
    throw error
  }
}

export async function _saveAlertHistorique(data) {
  console.log('🚨 _saveAlertHistorique called with:', data)
  
  try {
    const response = await _axios.post('alert/saveHistorique', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    console.log('🚨 Save alert historique response:', response.data)
    return response.data
  } catch (error) {
    console.error('🚨 Save alert historique error:', error)
    throw error
  }
}

export async function _saveAlertHistory(data) {
  console.log('🛠️ _saveAlertHistory called for intervention with:', data)
  
  try {
    const response = await _axios.post('alert/savehistory', {
      ...data,
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    console.log('🛠️ Save alert history intervention response:', response.data)
    return response.data
  } catch (error) {
    console.error('🛠️ Save alert history intervention error:', error)
    throw error
  }
}

// Report Generation API
export async function _generateTagReport(reportData) {
  console.log(' _generateTagReport called with:', reportData)
  
  try {
    const response = await _axios.post('repport/generate', reportData)
    
    console.log('Generate tag report response:', response)
    return response
  } catch (error) {
    console.error('Generate tag report error:', error)
    throw error
  }
}

// Report List API
export async function _getReportsList() {
  console.log('_getReportsList called')
  
  try {
    const requestData = {
      "srcObject": "sensor_repport"
    }
    
    console.log('Request data:', requestData)
    const response = await _axios.post('repport/list', requestData)
    
    console.log('Reports list response:', response)
    return response
  } catch (error) {
    console.error('Reports list error:', error)
    throw error
  }
}

// Delete Multiple Reports API
export async function _deleteMultipleReports(ids) {
  console.log('📋 _deleteMultipleReports called with ids:', ids)
  
  try {
    const requestData = {
      ids: ids // Format: "10286,10287"
    }
    
    console.log('📋 Delete multiple reports request data:', requestData)
    const response = await _axios.post('repport/remove', requestData)
    
    console.log('📋 Delete multiple reports response:', response)
    return response
  } catch (error) {
    console.error('📋 Delete multiple reports error:', error)
    throw error
  }
}
